
export const environment = {
  production: false,
  guildConfig: {
    env: 'dev',
    project: 'ctrl'
  }
}
